import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { flex } from '@/styles/layout';

export const Wrapper = styled.label<{ isChecked: boolean; disabled: boolean }>`
  width: 100%;
  max-width: 233px;
  padding: 10px 10px 10px 16px;
  border-radius: 8px;
  border: 1px solid ${COLORS.grey[400]};
  ${flex({ justifyContent: 'space-between' })};
  cursor: pointer;

  ${({ isChecked }) =>
    isChecked &&
    `
    border: 1px solid ${COLORS.green[500]};
    box-shadow: 0 0 2px 0 rgba(0, 134, 111, 0.60);
  `}

  ${({ disabled }) =>
    disabled &&
    `
    border: 1px solid ${COLORS.grey[400]};
    box-shadow: none;
    cursor: default;
  `}
`;
